module.exports = __webpack_public_path__ + "static/img/vaccine.36a4b10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/vaccine.png
// module id = 6NsX
// module chunks = 58